import { NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY } from "@nimble/react-requests/api-clients/caching-strategy";
import { useQuery } from "@tanstack/react-query";

import { getJobData } from "@/lib/api-clients/candidate-api-client";

export default function useJobPostingData({ jobId }: { jobId: string }) {
  return useQuery({
    queryKey: [`job-${jobId}`],
    queryFn: async () => {
      return await getJobData(
        NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY,
      )(jobId);
    },
    staleTime: 5 * 60 * 1000, // 5 minutes as new job postings are not added or scrapped frequently
  });
}
